import React from 'react';
import BentoCard from '../ui/BentoCard';

function MoreTab({
  isAuthenticated,
  isAdmin,
  userEmail,
  onLogin,
  onLogout,
  onOpenAdmin,
  onNavigateToTransferReference,
  onNavigateToNearbyStores,
}) {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="pt-2">
        <h1 className="text-2xl font-bold text-on-surface tracking-display">More</h1>
        <p className="text-sm text-on-surface-variant mt-1">Settings & tools</p>
      </div>

      {/* Profile Section */}
      <BentoCard>
        {isAuthenticated ? (
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-primary flex items-center justify-center text-white text-xl font-bold">
              {userEmail ? userEmail[0].toUpperCase() : 'U'}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-base font-semibold text-on-surface truncate">{userEmail}</p>
              <p className="text-sm text-on-surface-variant">Signed in</p>
            </div>
            <button
              onClick={onLogout}
              className="px-4 py-2 text-sm font-medium text-error bg-error-container/30 rounded-full hover:bg-error-container/50 transition-colors"
            >
              Sign Out
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-surface-container flex items-center justify-center">
              <span className="material-symbols-outlined text-on-surface-variant" style={{ fontSize: 28 }}>
                person
              </span>
            </div>
            <div className="flex-1">
              <p className="text-base font-semibold text-on-surface">Guest</p>
              <p className="text-sm text-on-surface-variant">Sign in to sync your cards</p>
            </div>
            <button
              onClick={onLogin}
              className="px-5 py-2 text-sm font-semibold text-on-primary bg-primary rounded-full hover:bg-primary-dark transition-colors"
            >
              Sign In
            </button>
          </div>
        )}
      </BentoCard>

      {/* Quick Links */}
      <div className="space-y-2">
        <h2 className="text-[11px] font-semibold text-on-surface-variant/70 uppercase tracking-label px-1">Tools</h2>

        <BentoCard
          onClick={onNavigateToTransferReference}
          className="flex items-center gap-4 !p-4 cursor-pointer"
        >
          <div className="w-10 h-10 rounded-xl bg-primary-light/50 flex items-center justify-center">
            <span className="material-symbols-outlined text-primary" style={{ fontSize: 22 }}>swap_horiz</span>
          </div>
          <div className="flex-1">
            <p className="text-sm font-semibold text-on-surface">Transfer Partners</p>
            <p className="text-xs text-on-surface-variant">View point transfer ratios & bonuses</p>
          </div>
          <span className="material-symbols-outlined text-on-surface-variant">chevron_right</span>
        </BentoCard>

        <BentoCard
          onClick={onNavigateToNearbyStores}
          className="flex items-center gap-4 !p-4 cursor-pointer"
        >
          <div className="w-10 h-10 rounded-xl bg-success-light/50 flex items-center justify-center">
            <span className="material-symbols-outlined text-success" style={{ fontSize: 22 }}>location_on</span>
          </div>
          <div className="flex-1">
            <p className="text-sm font-semibold text-on-surface">Nearby Stores</p>
            <p className="text-xs text-on-surface-variant">Find stores & check card benefits</p>
          </div>
          <span className="material-symbols-outlined text-on-surface-variant">chevron_right</span>
        </BentoCard>

        {isAdmin && (
          <BentoCard
            onClick={onOpenAdmin}
            className="flex items-center gap-4 !p-4 cursor-pointer"
          >
            <div className="w-10 h-10 rounded-xl bg-warning-light/50 flex items-center justify-center">
              <span className="material-symbols-outlined text-warning" style={{ fontSize: 22 }}>admin_panel_settings</span>
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-on-surface">Admin Panel</p>
              <p className="text-xs text-on-surface-variant">Manage card database & backfill jobs</p>
            </div>
            <span className="material-symbols-outlined text-on-surface-variant">chevron_right</span>
          </BentoCard>
        )}
      </div>

      {/* About */}
      <div className="space-y-2">
        <h2 className="text-[11px] font-semibold text-on-surface-variant/70 uppercase tracking-label px-1">About</h2>
        <BentoCard>
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-sm text-on-surface">Version</span>
              <span className="text-sm text-on-surface-variant">2.0.0</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-on-surface">Build</span>
              <span className="text-sm text-on-surface-variant">React 18 + Tailwind</span>
            </div>
          </div>
        </BentoCard>
      </div>
    </div>
  );
}

export default MoreTab;
